import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
import _slicedToArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import React__default, { createContext, useContext, useMemo } from 'react';
import { E as ErrorBoundary } from './vendor-8000eab9.js';
import { FallbackComponent } from '@sm/question-ui/helpers';
import { getTypeId } from '@sm/question-definitions';
var filterVisualizationByQuestionType = function filterVisualizationByQuestionType(typeId) {
  return function (qd) {
    var _qd = _slicedToArray(qd, 1),
      qts = _qd[0];
    return qts.includes(typeId);
  };
};
var declareVisualization = function declareVisualization(questionTypes, capabilities, component) {
  return [questionTypes, capabilities, component];
};
var providerAccessContext = createContext(null);
var useProviderAccessContext = function useProviderAccessContext() {
  var access = useContext(providerAccessContext);
  if (!access) {
    throw new Error('Must call useProviderAccessContext inside a properly setup Capability Provider');
  }
  var useUpstreamConfig = access.useUpstreamConfig,
    useVisualizationList = access.useVisualizationList;
  return {
    useVisualizationList: useVisualizationList,
    useUpstreamConfig: useUpstreamConfig
  };
};
/** providerFactory
 * Creates a helper component that enables a CapabilityProvider to store the appropriate configurations,
 * making them available to the visualizations through the generic controllers. It makes sure that all
 * Visualizations have the proper types passed onto them.
 * @param visualizationList list of visualization definitions for all the visualizations that will be
 * supported by this Capability Provider.
 * @returns React Context Provider accepting the appropriate configuration for the CapabilityProvider
 */
var providerFactory = function providerFactory(visualizationList) {
  var ctx = React__default.createContext(null);
  // TODO: further filter types to match the ones in the right indexes based on capability
  var useVisualizationList = function useVisualizationList(capability) {
    return visualizationList.filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        fs = _ref2[1];
      return fs.indexOf(capability) >= 0;
    });
  };
  var useUpstreamConfig = function useUpstreamConfig() {
    var config = useContext(ctx);
    if (!config) {
      throw new Error('Must call useUpstreamConfig inside a properly set up Capability Provider');
    }
    return config;
  };
  var providerValue = {
    useVisualizationList: useVisualizationList,
    useUpstreamConfig: useUpstreamConfig
  };
  return function ProvidersWrapper(_ref3) {
    var children = _ref3.children,
      value = _ref3.value;
    return React__default.createElement(ErrorBoundary, {
      FallbackComponent: FallbackComponent
    }, React__default.createElement(providerAccessContext.Provider, {
      value: providerValue
    }, React__default.createElement(ctx.Provider, {
      value: value
    }, children)));
  };
};
function UnsupportedVisualization(_ref4) {
  var typeId = _ref4.question.typeId;
  return React__default.createElement("div", null, "Unsupported Visualization for ", typeId);
}
var createVisualization = function createVisualization(capability, questionTypeId, visualizationOptions, upstreamActions, settings, renderProps) {
  var _ref5 = visualizationOptions.find(filterVisualizationByQuestionType(questionTypeId)) || [],
    _ref6 = _slicedToArray(_ref5, 3),
    VisualizationComponent = _ref6[2];
  if (!VisualizationComponent) {
    return function UnsupportedVisualizationWrapper(_ref7) {
      var question = _ref7.question;
      return React__default.createElement(UnsupportedVisualization, {
        question: question
      });
    };
  }
  return function VisualizationComponentWrapper(_ref8) {
    var question = _ref8.question,
      displayOptions = _ref8.displayOptions,
      namedSlots = _ref8.namedSlots,
      toExternalQuestion = _ref8.toExternalQuestion;
    return React__default.createElement(VisualizationComponent, {
      capability: capability,
      question: question,
      upstreamActions: upstreamActions,
      settings: settings,
      displayOptions: displayOptions,
      renderProps: renderProps,
      toExternalQuestion: toExternalQuestion,
      namedSlots: namedSlots
    });
  };
};

/** Finds and attaches a typeId to an `ExternalQuestion` */
var useExternalQuestionAugmentation = function useExternalQuestionAugmentation(externalQuestion, responseSet) {
  return useMemo(function () {
    var typeId = getTypeId(externalQuestion);
    if (!typeId) {
      throw new Error("Unsupported Question Type of family ".concat(externalQuestion.family, ", variant ").concat(externalQuestion.variant, "."));
    }
    if (responseSet !== undefined) {
      return _objectSpread(_objectSpread({}, externalQuestion), {}, {
        typeId: typeId
      }, responseSet);
    }
    return _objectSpread(_objectSpread({}, externalQuestion), {}, {
      typeId: typeId
    });
  }, [externalQuestion, responseSet]);
};
export { useExternalQuestionAugmentation as a, createVisualization as c, declareVisualization as d, providerFactory as p, useProviderAccessContext as u };